import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {BehaviorSubject, map, Observable, tap} from "rxjs";

import {SetPasswordRequest} from "@commons/models/remote.request/SetPasswordRequest";
import {WebResponse} from "@commons/models/remote.response/WebResponse";
import {User} from "@commons/models/domain/User";
import {GetProfileUserDataResponse} from "@commons/models/remote.response/GetProfileUserDataResponse";

import {BaseHttpService} from "@shared/services-http/base-http.service";
import {UserViewModel} from "@shared/view-models/user.viewmodel";
import { TokenStore } from '@shared/services/authentication/token.store';

@Injectable({
  providedIn: 'root'
})
export class UserHttpService extends BaseHttpService {

  private cachedUser?: User;

  get userViewModel(): UserViewModel | undefined {
    return this.cachedUser ? new UserViewModel(this.getClone(this.cachedUser)) : undefined;
  }

  public userData$: BehaviorSubject<UserViewModel> = new BehaviorSubject(null as any);

  private readonly TokenStoreRef = new TokenStore();

  constructor(
    private httpClient: HttpClient,
  ) {
    super();
  }

  setUserPassword(request: SetPasswordRequest): Observable<WebResponse> {
    return this.httpClient.post<WebResponse>(this.getUrl('/SetProfileUserPassword'), request);
  }

  getProfileUserData(): Observable<User> {
    if (this.cachedUser) {
      this.setUserData();
      JSON.stringify(this.cachedUser);
      return this.getClone(this.cachedUser);
    }
    const request = {notification: true}; //niewiadomo po co to jest
    return this.httpClient.post<GetProfileUserDataResponse>(this.getUrl('/GetProfileUserData'), request)
      .pipe(
        map(response => response.Result),
        tap((user => {
          if (user) {
            this.cachedUser = this.getClone((user as any).Result);
            this.setUserData();
            return;
          }

          this.TokenStoreRef.removeToken();
          document.location.reload();
        })));
  }

  private setUserData(): void {
    this.userData$.next(this.userViewModel as UserViewModel);
  }

}
